module.exports = __webpack_public_path__ + "media/images/front/pc/article/mv-e362aa3837387f3eaae1dd0200b6abce.png";